var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white"},[_c('HeaderContent'),_c('div',{staticClass:"lg:flex md:flex gap-3 container"},[_c('div',{staticClass:"lg:w-4/6 md:w-4/6 w-full"},[_c('AboutCourse'),_c('CourseContent')],1),_c('div',{staticClass:"lg:w-2/6 md:w-3/6 w-full pb-12"},[_c('RightSection')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }